<template>
  <v-sheet
    :dark="$theme.dark"
    :light="$theme.light"
    class="expande-horizontal sheet-container pt-2"
  >
    <v-flex xs12 class="pr-1">
      <Filters :filter="filter" />
      <Report :filtereds="filtereds" />
      <!-- <List :filtereds="filtereds" /> -->
      <EmptyList
        :iniciarCadastro="iniciarCadastro"
        v-if="filtereds.length === 0"
      />
    </v-flex>
  </v-sheet>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
import Report from "../components/Report.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      filter: {},
      options: [
        {
          nome: "Novo report",
          action: this.iniciarCadastro,
          icon: "mdi-plus"
        }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "reports",
          path: "/reports"
        }
      ]
    };
  },
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm,
    Report
  },
  computed: {
    ...mapGetters([
      "get_reports_filtros",
      "getLoggedUser",
      "get_report",
      "get_reports",
      "getPersonalizedLoading"
    ]),
    filtereds() {
      if (this.filter.search) {
        return this.get_reports.docs.filter(item => {
          return (
            (item.nome &&
              item.nome
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.email &&
              item.email
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.telefone &&
              item.telefone.includes(this.filter.search.toLowerCase()))
          );
        });
      } else {
        return this.get_reports.docs;
      }
    }
  },
  methods: {
    excluir_report_dialog(item) {
      let text = "Deseja remover este report?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_report",
        action_value: item
      });
    },
    getLinkById(id) {
      return this.getLinkById[id];
    },
    ...mapActions([
      "abre_modal_view_tenant",
      "listar_tenants",
      "listar_reports",
      "criar_estoque",
      "listar_reportcategorias",
      "criar_report",
      "listar_estoques",
      "atualizar_report",
      "setPersonalizedLoading",
      "createConfirmAction"
    ]),
    criarOuAtualizar() {
      if (this.get_report._id) {
        this.atualizar_report();
      } else {
        this.criar_report();
      }
    },
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_report", { new: true });
      this.$store.commit("setLinks", []);
      this.setPersonalizedLoading("animate__fadeInUp");
    },
    createOrUpdate() {
      if (this.$refs.form.validate()) {
        if (this.get_report._id) {
          this.atualizar_report();
        } else {
          this.criar_report();
        }
      }
    }
  },
  created() {
    this.listar_reports();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
</style>
